






export const getWrap=(parent)=>{
const{wrap,name}=parent;

if(typeof wrap!=="boolean"){
return name==="Error"
}

if(Object.hasOwn(parent,"wrap")){

delete parent.wrap
}

return wrap
};